import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { ArrowRight, Camera } from "lucide-react";

export default function Portfolio() {
  const [galleries, setGalleries] = useState([]);
  useEffect(() => { api.get("/galleries").then(r => setGalleries(r.data)).catch(()=>{}); }, []);

  return (
    <div data-testid="portfolio-page" className="pt-32">
      <SEO title="Portfolio" path="/portfolio"
           description="A look at the moments we've captured — weddings, engagements, Afghan weddings, destination weddings, bridal sessions and more." />

      <section className="section-pad pb-12 max-w-[1400px] mx-auto text-center">
        <div className="eyebrow">Portfolio</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light mt-4 tracking-tight">
          Our <em className="text-[#D4AF37] not-italic">Galleries</em>
        </h1>
        <p className="text-white/55 mt-4 max-w-2xl mx-auto">
          Each gallery is a quiet collection of moments we've been honored to capture.
        </p>
      </section>

      <section className="px-6 md:px-10 max-w-[1600px] mx-auto pb-24">
        {galleries.length === 0 ? (
          <div className="text-center text-white/40 py-20">No galleries yet.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {galleries.map((g) => (
              <Link key={g.id} to={`/portfolio/${g.slug}`}
                data-testid={`gallery-card-${g.slug}`}
                className="group block relative aspect-[4/5] overflow-hidden bg-[#0a0a0a]">
                {g.cover_image ? (
                  <img src={g.cover_image} alt={g.title}
                       style={{ objectPosition: `${g.cover_focal_x ?? 50}% ${g.cover_focal_y ?? 50}%` }}
                       className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center text-white/15"><Camera size={48} /></div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-8">
                  <div className="text-[0.6rem] tracking-[0.3em] uppercase text-[#D4AF37]">{g.photo_count} {g.photo_count === 1 ? "photo" : "photos"}</div>
                  <h3 className="font-serif text-3xl mt-2 group-hover:text-[#D4AF37] transition">{g.title}</h3>
                  {g.description && <p className="text-sm text-white/65 mt-2 line-clamp-2">{g.description}</p>}
                  <span className="inline-flex items-center gap-2 mt-4 text-xs tracking-[0.2em] uppercase text-white/70 group-hover:text-[#D4AF37] transition">
                    View Gallery <ArrowRight size={12}/>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
